namespace e5.ScrollViewScale {
    class ScrollViewScaleCover implements IScrollViewScale {
        public getScale(view: ScrollView): number {
            return view.width / view.contentWidth;
        }
    }

    export const CoverWidth = new ScrollViewScaleCover();
}